<template>
  <div>
    <span v-if="label" class="title">{{label}}：</span>
    <div class="company-tag-box" style="overflow:hidden;">
      <!-- <el-tag
        v-for="tag in showTags(value.keywords)"
        :key="tag"
        size="small"
        style="margin:0 4px 4px 0;cursor:pointer;font-size:14px"
        >{{ getTagLable(tag) }}</el-tag
      > -->
      <span v-for="(tag,ind) in showTags"
            :key="tag"
            class="high-light-text mb10"
            style="font-size:12px;color: #bbb4b4;">
        {{ getTagLable(tag) }}{{ind===(showTags.length-1)?'':'；'}}
      </span>
    </div>
    <div :class="[value.content?'':'gray-text','value company-pre']">
      <p v-if="value.content">{{value.content}}</p>
      <p v-else style="color:#bdbdbd">小阿暂时没有拿到有效数据，快来补充吧<span class="link-text" @click="quickEdit"><i class="el-icon-edit-outline" style="cursor:pointer;margin: 0 4px;"></i>补充</span></p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: Object, default: () => ({ keywords: {}, content: '' }) },
    label: { type: String, default: '' },
    translate: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      needToBeTranslate: false,
    }
  },
  computed: {
    showTags() {
      const tags = this.value.keywords
      const result = []
      Object.keys(tags).forEach(key => {
        if (tags[key]) result.push(key)
      })
      return result
    },
  },
  mounted() {
    this.needToBeTranslate = Object.keys(this.translate).length > 0
  },
  methods: {
    getTagLable(key) {
      if (this.needToBeTranslate) return this.translate[key]
      else return key
    },
    quickEdit(){
      this.$emit('quickEdit')
    },
  },
}
</script>
<style scoped>
.value {
  background: #2478b526;
  border-radius: 2px;
  font-weight: 400;
  /* color: #666666; */
  line-height: 22px;
  margin-bottom: 10px;
}
.high-light-text {
  font-size: 14px;
  font-weight: 400;
  color: #1890ff;
  line-height: 22px;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  text-indent: 2em;
}
.company-pre {
  text-indent: 0;
  padding: 10px 20px 20px;
  width: 100%;
  box-sizing: border-box;
  margin: 0;
}
.link-text {
  color: #409eff;
  cursor: pointer;
}
</style>
